const API_URL = process.env.REACT_APP_URL;

const getToken = () => {
  try {
    return JSON.parse(localStorage.getItem("token"));
  } catch (e) {
    return null;
  }
};

const authFetch = async (path, options = {}) => {
  const headers = new Headers(options.headers || {});
  const isFormData = options.body instanceof FormData;
  if (!isFormData && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  headers.set("Accept", "application/json");
  const token = getToken();
  if (token) headers.set("Authorization", `Bearer ${token}`);

  const response = await fetch(`${API_URL}${path}`, { ...options, headers });
  const text = await response.text();
  const json = text ? JSON.parse(text) : null;
  if (!response.ok) {
    const message = (json && (json.message || json.error)) || response.statusText;
    throw new Error(Array.isArray(message) ? message.join(", ") : message);
  }
  return json;
};

export const getImageUrl = (imgPath) => {
  if (!imgPath) return "";
  if (/^https?:\/\//i.test(imgPath)) return imgPath;
  if (imgPath.startsWith("/")) return `${API_URL}${imgPath}`;
  return `${API_URL}/${imgPath}`;
};

const buildFilterQuery = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.status) params.append("filter", `status||$eq||${filters.status}`);
  if (filters.category_id) params.append("filter", `category_id||$eq||${filters.category_id}`);
  if (filters.search) params.append("filter", `search||$cont||${filters.search}`);
  if (filters.page) params.append("page", filters.page);
  if (filters.limit) params.append("limit", filters.limit);
  return params.toString();
};

// ---- Categories ----
export const listCategories = () =>
  authFetch("/admin/salat-mahsool/categories").then((json) => json.data);

export const getCategory = (id) => authFetch(`/admin/salat-mahsool/categories/${id}`);

export const createCategory = (data) =>
  authFetch("/admin/salat-mahsool/categories", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const updateCategory = (id, data) =>
  authFetch(`/admin/salat-mahsool/categories/${id}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });

export const deleteCategory = (id) =>
  authFetch(`/admin/salat-mahsool/categories/${id}`, { method: "DELETE" });

export const uploadCategoryImage = (id, file) => {
  const formData = new FormData();
  formData.append("image", file);
  return authFetch(`/admin/salat-mahsool/categories/${id}/image`, {
    method: "POST",
    body: formData,
  });
};

export const deleteCategoryImage = (id) =>
  authFetch(`/admin/salat-mahsool/categories/${id}/image`, { method: "DELETE" });

// ---- Products ----
export const listProducts = (filters = {}) => {
  const query = buildFilterQuery(filters);
  return authFetch(`/admin/salat-mahsool/products${query ? `?${query}` : ""}`);
};

export const getProduct = (id) => authFetch(`/admin/salat-mahsool/products/${id}`);

export const createProduct = (data) =>
  authFetch("/admin/salat-mahsool/products", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const updateProduct = (id, data) =>
  authFetch(`/admin/salat-mahsool/products/${id}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });

export const deleteProduct = (id) =>
  authFetch(`/admin/salat-mahsool/products/${id}`, { method: "DELETE" });

export const uploadProductImages = (id, files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("images", file));
  return authFetch(`/admin/salat-mahsool/products/${id}/images`, {
    method: "POST",
    body: formData,
  });
};

export const deleteProductImages = (id, imageIndices) =>
  authFetch(`/admin/salat-mahsool/products/${id}/images`, {
    method: "DELETE",
    body: JSON.stringify({ imageIndices }),
  });

// ---- Orders ----
export const listOrders = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.status) params.append("status", filters.status);
  if (filters.buyer_id) params.append("buyer_id", filters.buyer_id);
  if (filters.fromDate) params.append("fromDate", filters.fromDate);
  if (filters.toDate) params.append("toDate", filters.toDate);
  if (filters.page) params.append("page", filters.page);
  if (filters.limit) params.append("limit", filters.limit);
  const query = params.toString();
  return authFetch(`/admin/salat-mahsool/orders${query ? `?${query}` : ""}`);
};

export const getOrder = (id) => authFetch(`/admin/salat-mahsool/orders/${id}`);

export const updateOrderStatus = (id, data) =>
  authFetch(`/admin/salat-mahsool/orders/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });

// ---- Units ----
export const getUnits = () => authFetch("/units");

// ---- States (same list used by other forms, e.g. Offers) ----
export const getStates = () =>
  authFetch("/admin/state").then((json) => (Array.isArray(json) ? json : json.data || []));

